import { createReducer, on, Action } from '@ngrx/store';
import { remove } from 'lodash';

import { PremiitError } from '../../utils/premiit-error';
import * as rolesActions from '../actions/roles.action';
import { RoleView } from '../../pages/roles/role-view';

export interface RolesState {
  data: RoleView[];
  selected: RoleView;
  loading: boolean;
  color: string;
  error: PremiitError;
}

const rolesInitState: RolesState = {
  data: [],
  selected: null,
  loading: false,
  color: null,
  error: null,
};

const _rolesReducer = createReducer(rolesInitState,
  on(rolesActions.getRolesAction, (state: RolesState) => ({ ...state, loading: false })),
  on(rolesActions.getRolesSuccessAction, (state: RolesState, { roles }) => ({
    ...state,
    data: [...roles],
    loading: false,
    error: null,
  })),
  on(rolesActions.getRolesErrorAction, (state: RolesState, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(rolesActions.selectRole, (state: RolesState, { role }) => ({
    ...state,
    selected: { ...role }
  })),
  on(rolesActions.unSelectRole, (state: RolesState) => ({
    ...state,
    selected: null,
  })),
  on(rolesActions.setColor, (state: RolesState, { color }) => ({
    ...state,
    color
  })),
  on(rolesActions.createRoleAction, (state: RolesState) => ({
    ...state,
    loading: true,
  })),
  on(rolesActions.createRoleSuccessAction, (state: RolesState, { role }) => {
    const roles: RoleView[] = [...state.data];
    roles.push(role);
    return {
      ...state,
      data: roles,
      loading: false,
      error: null,
    };
  }),
  on(rolesActions.createRoleErrorAction, (state: RolesState, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(rolesActions.deleteRoleAction, (state: RolesState) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(rolesActions.deleteRoleSuccessfullyAction, (state: RolesState, { role }) => {
    const roles = [...state.data];
    remove(roles, (item: RoleView) => (role.id === item.id));
    return {
      ...state,
      data: roles,
      loading: false,
      error: null,
      selected: null,
      color: null,
    };
  }),
  on(rolesActions.deleteRoleError, (state: RolesState, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(rolesActions.updateRoleAction, (state: RolesState) => ({ ...state, loading: true })),
  on(rolesActions.updateRoleSuccessAction, (state: RolesState, { role }) => {
    const roles = [...state.data];
    roles.map((storeRole: RoleView) => {
      if (storeRole.id === role.id) {
        storeRole = role;
      }
      return storeRole;
    });
    return {
      ...state,
      data: roles,
      loading: false,
      selected: null,
      color: null,
    };
  }),
  on(rolesActions.updateRoleErrorAction, (state: RolesState, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);

export function RolesReducer(state: RolesState, action: Action): any {
  return _rolesReducer(state, action);
}
